// NOTE: adjust this import to your actual shared API helper path if different.
// Expected helpers: postBiz(service, action, payload), rows(response), json(response)
import { postBiz, rows, json } from '../core/coreapi';

export const normalizeCaPackage = (r:any) => ({
  id: r.id ?? r.rid ?? r.recid,
  rid: r.rid ?? r.recid ?? r.id,
  shc: r.shc ?? r.shortcode ?? '',
  nam: r.nam ?? r.recname ?? r.title ?? '',
  fyr: r.fyr ?? r.fiscalyear ?? '',
  pst: r.pst ?? r.status ?? '',
  bvi: r.bvi ?? r.budgetversionid ?? null,
  ppi: r.ppi ?? r.ppmid ?? null,
  tam: Number(r.tam ?? r.totalamount ?? 0),
  dsc: r.dsc ?? r.description ?? '',
  raw: r,
});

export const normalizeCaDecision = (r:any) => ({
  id: r.id ?? r.rid ?? r.recid,
  rid: r.rid ?? r.recid ?? r.id,
  packageid: r.packageid ?? r.cpi ?? null,
  decisiontype: r.decisiontype ?? r.dty ?? '',
  decisionscope: r.decisionscope ?? r.dscop ?? r.dsc ?? '',
  decisiondate: r.decisiondate ?? r.ddt ?? '',
  meetingreference: r.meetingreference ?? r.mrf ?? '',
  observations: r.observations ?? r.obs ?? '',
  remarks: r.remarks ?? r.rmk ?? '',
  raw: r,
});

export const createCaPackage = (payload: any) =>
  json(postBiz({s: 'careviewpackage', a: 'create',...payload} ));

export const submitCaPackage = (packageId: number, notes = '') =>
  json(postBiz({s: 'careviewpackage', a: 'submit', rid: packageId, nts: notes }));

export const fetchCaPackages = async (status = '', fiscalYear = '') =>
  rows(await postBiz({s: 'careviewpackage', a: 'find', pst: status || null, fyr: fiscalYear || null, pgo: 0, pgl: 100 })).map(normalizeCaPackage);

export const fetchCaPackageCards = (packageId: number) =>
  json(postBiz({s: 'careviewpackage', a: 'cards', rid: packageId}));

export const recordCaDecision = (payload: any) =>
  json(postBiz({s: 'cadecision', a: 'record',...payload}));

export const fetchCaDecisions = async (packageId: number) =>
  rows(await postBiz({s: 'cadecision', a: 'find', rid: packageId})).map(normalizeCaDecision);
